import React from 'react';
import { KYCTagBox } from './NotesPreviewCardStyles';
import InfoTag from 'components/common/SectionHeader/InfoTag';

interface KYCTagsDisplayProps {
  isSignificantChange: boolean;
  isMeaningfulInteraction: boolean;
  isPortfolioReview: boolean;
}

const KYCTagsDisplay: React.FC<KYCTagsDisplayProps> = ({
  isSignificantChange,
  isMeaningfulInteraction,
  isPortfolioReview,
}) => (
  <KYCTagBox>
    {isSignificantChange && <InfoTag tagTitle="Significant Change" fontSize="small" />}
    {isMeaningfulInteraction && <InfoTag tagTitle="Meaningful Interaction" fontSize="small" />}
    {isPortfolioReview && <InfoTag tagTitle="Portfolio Review" fontSize="small" />}
  </KYCTagBox>
);

export default KYCTagsDisplay;
